<template>
  <div />
</template>

<script>
export default {
  mounted() {
    const utmCampaignParam = this.$route.query.a;
    const isTiendanube = this.$route.query.tiendanube === "true";

    const baseUrl = isTiendanube
      ? this.$t("footerAd.redirectUrlTiendanube")
      : this.$t("footerAd.redirectUrl");

    const params = `?utm_source=footer_ad&utm_medium=email&utm_campaign=${utmCampaignParam}`;

    window.location.href = `${baseUrl}${params}`;
  },
};
</script>

<style></style>
